import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-48 p-2 mt-8 mb-4 font-bold text-center text-white uppercase truncate bg-primary" }
const _hoisted_2 = { class: "space-y-1" }
const _hoisted_3 = ["title"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Vacant")

import {
  FactionReigningChampion,
  FactionReigningChampions,
} from '@/typings/faction';

interface Props {
  brandChampions: FactionReigningChampions;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    brandChampions: null
  },
  setup(__props: any) {



const champTitle = (champ: FactionReigningChampion) => {
  if (champ.Champion) {
    return `Since ${champ.EventName} ${
      champ.Streak > 1 ? `(x${champ.Streak} streak)` : ''
    }`;
  }
  return '';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.brandChampions.Brand), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.brandChampions.Champions, (champ) => {
        return (_openBlock(), _createElementBlock("div", {
          key: champ.Champion,
          title: champTitle(champ)
        }, [
          (champ.Champion)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(champ.Champion) + " x" + _toDisplayString(champ.Reigns), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_4
              ], 64))
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})